import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Category } from "@nicsmith/shared_types";
import { categoriesApi } from "../api/categoriesApi";
import i18n from "i18next";

interface CategoryState {
  categories: (Category & { isOpened: boolean })[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: CategoryState = {
  categories: null,
  loading: true,
  error: null,
};

const transformCategories = (
  categories: Category[]
): (Category & { isOpened: boolean })[] => {
  return categories.map((category) => ({
    ...category,
    isOpened: false,
  }));
};

const categoryListSlice = createSlice({
  name: "categoryList",
  initialState,
  reducers: {
    toggleCategory: (state, action: PayloadAction<number>) => {
      const category = state.categories?.find(
        (cat) => cat.id === action.payload
      );
      if (category) {
        category.isOpened = !category.isOpened;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        categoriesApi.endpoints.getAllCategories.matchPending,
        (state) => {
          state.loading = true;
          state.error = null;
          state.categories = null;
        }
      )
      .addMatcher(
        categoriesApi.endpoints.getAllCategories.matchFulfilled,
        (state, action: PayloadAction<Category[]>) => {
          state.categories = transformCategories(action.payload);
          state.loading = false;
          state.error = null;
        }
      )
      .addMatcher(
        categoriesApi.endpoints.getAllCategories.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error?.message || i18n.t("errors.failedToFetchCategories", "Failed to fetch categories");
        }
      );
  },
});

export const { toggleCategory } = categoryListSlice.actions;

export default categoryListSlice.reducer;
